@if (!hidden) {
    <ms-highlights-marquee [tiles]="tiles" [backgroundContainerConfig]="backgroundContainerConfig" [globalLinkConfig]="globalLinkConfig" />
}
